import * as React from 'react';
import styles from './Title.module.scss';

import background from '../../assets/img/background.svg';
import logo from '../../assets/img/logo-white.svg';
import { Container } from '@mui/material';

export class Title extends React.Component<{}, {}> {
    public render() {
        return (
            <Container className={styles.titleContainer} max-width='sm' >
                <div className={styles.thumbnail}>
                    <img src={background}
                        className={styles.tokenimagehomeMasthead}
                        alt='backround title'
                    />
                    <div className={styles.title}>
                        <img src={logo} alt='logo' />
                        <h1>Welcome to Themis</h1>
                    </div>
                </div>
            </Container>
        )
    }
}